(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Track', Track);

    Track.$inject = ['$resource'];

    function Track ($resource) {
        var resourceUrl =  'api/tracks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/tracks/filter', method: 'GET', isArray: true},
            'findAllByChart': {url: 'api/tracks/by-chart', method: 'GET', isArray: true}
        });
    }
})();
